import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function PropertyIntro() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: '-100px'
  });
  return <section id="overview" ref={sectionRef} className="w-full bg-villa-bg py-24 md:py-32 px-6 md:px-10 transition-colors duration-500" aria-label="O projektu" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-villa-gold text-[12px] tracking-[0.3em] uppercase font-inter font-light mb-6" data-id="element-141">
          O projektu
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: 'easeOut'
      }} className="font-playfair text-villa-text text-3xl md:text-4xl lg:text-5xl font-medium mb-12 leading-tight" data-id="element-142">
          Komorní bydlení v centru dění
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mb-20" data-id="element-143">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.2,
          ease: 'easeOut'
        }} className="font-inter text-villa-text/60 text-base leading-[1.9] font-light" data-id="element-144">
            Rezidenční projekt Mezírka představuje unikátní příležitost pro ty,
            kteří hledají klidné a soukromé bydlení přímo v centru Brna. S
            pouhými třemi bytovými jednotkami nabízí projekt nevídanou míru
            soukromí a exkluzivity.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.3,
          ease: 'easeOut'
        }} className="font-inter text-villa-text/60 text-base leading-[1.9] font-light" data-id="element-145">
            Každý detail byl pečlivě navržen s ohledem na maximální komfort
            budoucích obyvatel. Od prémiových dřevěných podlah, přes moderní
            technologie vytápění a chlazení, až po špičkovou akustickou izolaci.
            K dispozici je také vlastní garážové stání a nový výtah.
          </motion.p>
        </div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.4,
        ease: 'easeOut'
      }} className="border-t border-b border-[var(--color-border)] py-10" data-id="element-146">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 md:gap-0" data-id="element-147">
            <div className="text-center md:border-r md:border-[var(--color-border)]" data-id="element-148">
              <p className="font-playfair text-villa-text text-3xl md:text-4xl font-medium mb-2" data-id="element-149">
                3
              </p>
              <p className="font-inter text-villa-text/40 text-[12px] tracking-[0.2em] uppercase font-light" data-id="element-150">
                Bytové jednotky
              </p>
            </div>
            <div className="text-center md:border-r md:border-[var(--color-border)]" data-id="element-151">
              <p className="font-playfair text-villa-text text-3xl md:text-4xl font-medium mb-2" data-id="element-152">
                2+kk / 3+kk
              </p>
              <p className="font-inter text-villa-text/40 text-[12px] tracking-[0.2em] uppercase font-light" data-id="element-153">
                Dispozice
              </p>
            </div>
            <div className="text-center md:border-r md:border-[var(--color-border)]" data-id="element-154">
              <p className="font-playfair text-villa-text text-3xl md:text-4xl font-medium mb-2" data-id="element-155">
                2026
              </p>
              <p className="font-inter text-villa-text/40 text-[12px] tracking-[0.2em] uppercase font-light" data-id="element-156">
                Dokončení (Q4)
              </p>
            </div>
            <div className="text-center" data-id="element-157">
              <p className="font-playfair text-villa-text text-3xl md:text-4xl font-medium mb-2" data-id="element-158">
                2
              </p>
              <p className="font-inter text-villa-text/40 text-[12px] tracking-[0.2em] uppercase font-light" data-id="element-159">
                Parkovací stání
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}